<style>
.pagination-wrapper{
  display:flex;
  justify-content:center;
  align-items:center;
  gap:6px;
  margin-top:20px;
  margin-bottom: 20px;
  flex-wrap:wrap;
}

.pagination-wrapper button{
  border:none;
  background:#2c3e50;
  color:white;
  padding:3px 10px;
  border-radius:5px;
  cursor:pointer;
  font-size: 14px;
}

.pagination-wrapper button.active{
  background:#197fe6;
}

.pagination-wrapper button:disabled{
  opacity:0.5;
  cursor:not-allowed;
}

/**price card************** */
  .price-card {
    cursor: pointer;
    display: block;
    /*transition: 0.3s ease;*/
    position: relative;
    background: #fff;
  }

  /* hide radio */
  .price-card input {
    display: none;
  }

  .price-inner{
     border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 4px 10px;
  }

   /* ACTIVE STATE */
  .price-card input:checked+.price-inner {
    /*border-top: 1px solid #22C55E;*/
  }

  .price-card input:checked~.price-inner,
  .price-card input:checked+.price-inner {
    /*border-top: 1px solid #22C55E;*/
  }

  .price-card input:checked+.price-inner .discount-price {
    color: #22C55E;
  }



  /* Alternative clean active style */
  .price-card input:checked+.price-inner {
    margin-top: -4px;
  }

  .price-card input:checked~.price-inner,
  .price-card input:checked+.price-inner {
    outline: 2px solid #22C55E;
    border-color: #22C55E;
  }


</style>
<template>
    

      <!-- Content -->
      <div class="admin-content">

                <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
  <!-- Left -->
  <div>
    <h5 class="mb-0 fw-semibold text-color">Orders Management</h5>
    <p class="mb-0 text-muted small">
      Manage your orders and statuses
    </p>
  </div>
  <!-- Right -->
  
</div>

      <div class="row">
      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-primary">Complete Order L7D</p>
              <p class="card-big-p text-color"> 
                   <PriceFormat :Price="dataz.complete_7"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-danger">Canceled Order L7D</p>
              <p class="card-big-p text-color">
                 <PriceFormat :Price="dataz.canceled_7"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-green">Complete Order L30D</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.complete_30"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-orange">Canceled Order L30D</p>
              <p class="card-big-p text-color">
               <PriceFormat :Price="dataz.canceled_30"/>
              </p>
            </div>
          </div>


        </div>
      </div>
    </div>

        <div class="row align-items-stretch">
               <div class="col-12">

                            <div v-if="user.role == 1" class="product-filter-bar d-flex justify-content-between align-items-center flex-wrap gap-3 mob-mt">

  <!-- Left: Search -->
  <div class="filter-search d-flex">
    <input
      type="text"
      v-model="this.search_order"
      class="filter-search-input"
      placeholder="Search order..."
    />
    <button class="filter-search-btn">
      <i class="fas fa-search"></i>
    </button>
  </div>

  <!-- Right: Filters -->
  <div class="filter-actions d-flex align-items-center gap-2 mob-grid">

     <select class="filter-select" v-model="this.selectedFollowup" @change="handleFollowup()">
      <option selected :value="5">
                         All Orders
                        </option>
                        <option :value="0">Not Yet</option>
                        <option :value="1">Hapatikani</option>
                        <option :value="2">Hapokei</option>
                        <option :value="3">Ahadi</option>
      
    </select>
   
    <select class="filter-select" v-model="this.selectedStatus" @change="handleStatus()">
      <option selected :value="0">
                         All Status
                        </option>

                        <option v-for="status_ in order_status" :key="status_.id" :value="status_.id">
                          {{ status_.label }}
                        </option>
      
    </select>

   
  </div>
</div>

                <div class="card recent-orders-card mt-3">

              <!-- Card Header -->
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0 fw-semibold">
                  <span class="text-color">Recent Orders</span>
                </h5>
              <!--button class="btn-transparent text-primary text-sm">
                    <span class="fas fa-download"></span> Export
                </button-->
               
              </div>

              <!-- Card Body -->
                 <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table orders-table mb-0">
                <thead class="">
                  <tr>
                    <th class="">NO</th>
                    <th class="td-wd-user">CLIENT</th>
                    <th class="td-wd">CONTACTS</th>
                   
                    <th class="td-wd-product">SUMMARY</th>
                    <th class="">TOTAL</th>
                     <th class="td-wd">DATETIME</th>
                    <th>STATUS</th>
                    <th v-if="user.role == 1" class="td-wd-sm">ASSIGN-STAFF</th>
                     <th v-if="user.role > 1" class="td-wd">LOCATION</th>
                     <th>FOLLOWUP</th>
                      <th class="text-end">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in paginatedProducts" :key="order.id">
                    <td class="text-color text-md text-bold">{{ index + 1 }}</td>
                    <td class="text-sm">
                      <UserAvatar v-if="order.avator == 'user.jpg'" :fullName="order.fulname" imageUrl="" />
                      <UserAvatar v-else :fullName="order.fulname" :imageUrl="this.$store.state.img_url + order.avator" />
                    </td>
                     <td class="text-color text-sm text-bold">
                       <PhoneFormat :Phone="order.contacts"/>
                     </td>
                  
                    <td class="text-color text-sm text-muted text-capitalize">({{ order.quantity }}) {{ order.summary  }}</td>
                    <td class="text-color text-sm text-bold">
                      <PriceFormat :Price="order.total"/>
                    </td>
                      <td class="text-muted text-sm">
                        <DateFormat :Date_="order.created_at"/>
                      </td>
                    <td>
                      <OrderStatus :statusName="order.status_name" :statusID="order.status_id" />
                    </td>
                    <td v-if="user.role == 1" class=" fw-semibold text-muted text-sm">
                      <span v-if="order.status_id > 1">
                        {{ order.staff }}
                      </span>

                      <!-- If pending show select -->
                      <select class="td-select" v-else v-model="this.selectedStaff" @change="handleAssign(order)">
                        <option selected disabled :value="0">
                          Select staff
                        </option>

                        <option v-for="staff in staffs" :key="staff.id" :value="staff.id">
                          {{ staff.username }}
                        </option>
                      </select>
                    </td>
                    <td  v-if="user.role > 1" class="text-color text-sm text-bold">{{ order.order_location }}</td>
                    <td>
                      <OrderFollowup :Followup="order.followup" />
                    </td>
                    <td class="text-end text-md">
                            <div class="order-actions">
                              <button @click="addConfirmModel(order)" data-bs-toggle="modal" data-bs-target="#addConfirm" class="order-action-btn text-primary edit" title="Edit">
                               Open
                              </button>
                             
                            </div>
                          </td>
                  </tr>

                </tbody>
              </table>
            </div>
  
           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
          </div>

            </div>
               </div>
        </div>

                <!--manual enter status-->
    <div class="modal fade" id="addConfirm" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Order Details</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body custom-modal-body">
            <div class="row">
               <div class="col-sm-12 col-md-6">
                <img :src="this.$store.state.img_url + order.thumbnail" width="100%" height="auto" alt="">
               </div>
               <div class="col-sm-12 col-md-6">
                <p class="mb-2 text-color"><i>Order ID : #{{ order.id }}</i></p>
                
                 <p class="mb-0 text-muted text-capitalize">Fullname : {{ order.fulname }}</p>
                 <p class="mb-0 text-muted">Phone No : {{ order.contacts }}</p>
                 <p class="mb-0 text-muted">Location : {{ order.order_location }}</p>
                 <p class="mb-0 text-muted">Quantity : {{ order.quantity }}</p>
                 <p class="mb-0 text-muted">Price : {{ order.total }}</p>
                 <p class="mb-0 text-color text-capitalize">{{ order.summary  }}, </p>
                 <p class="mb-0 text-muted text-sm">{{ order.created_at  }}, </p>
               </div>

               <div class="col-12 d-flex justify-content-between">
                 <div class="mt-3 mb-3">
                  <h6 v-if="order.followup == 2" class="">Hakupokea</h6>
                   <h6 v-if="order.followup == 1" class="">Hakupatikana</h6>
                    <h6 v-if="order.followup == 3" class="">Ali Ahidi</h6>
                  
                </div>
                <div v-if="user.role == 3 && order.status_id == 2" class="mt-3 mb-3 d-flex gap-2">
                 <button type="button" v-if="order.followup != 2" @click="updateFullowup(2, order.id)" class="btn-orange-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Hapokei
                </button>
                <button type="button" v-if="order.followup != 1" @click="updateFullowup(1, order.id)" class="btn-danger-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Hapatikani
                </button>
                <button type="button" v-if="order.followup != 3" @click="updateFullowup(3, order.id)" class="btn-green-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Ahadi
                </button>
                </div>

                 <div v-if="user.role == 2" class="mt-3 mb-3 d-flex gap-2">
                 <button type="button" v-if="order.followup != 2" @click="updateFullowup(2, order.id)" class="btn-orange-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Hapokei
                </button>
                <button type="button" v-if="order.followup != 1" @click="updateFullowup(1, order.id)" class="btn-danger-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Hapatikani
                </button>
                <button type="button" v-if="order.followup != 3" @click="updateFullowup(3, order.id)" class="btn-green-icon font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Ahadi
                </button>
                </div>
               
               </div>
            </div>

            <!--foradmin-->

            <div class="" v-if="user.role == 1">
             
              <div v-if="order.status_id == 1">
                 <p class="mt-3">Choose staff Below to Assign this Order</p>
                  <div class="row mt-3">
                    <div class="col-md-4 col-sm-6" v-for="staff in staffs">
                       <label class="price-card">
                  <input type="radio" v-on:change="assignStaff(staff)" name="priceOption" :value="staff.id">

                  <div class="price-inner">
                     <span>{{ staff.username }}</span>
                  </div>
                </label>
                    </div>
                  </div>
                  <button type="button" @click="assignStaffOrder" class="btn-primary font-bold mt-3">
                  <i class="fas fa-check me-2"></i>
                  Assign {{ assign_staff_name }}
                </button>
              </div>
              <div class="mt-3" v-else>
                <div class="d-flex justify-content-between">
                    <OrderStatus class="" :statusName="order.status_name" :statusID="order.status_id" />
                    <h6 class="text-capitalize text-muted">{{ order.staff }}</h6>
                </div>
              </div>
            </div>
            
       <!--for sales-->
            <div v-if="(user.role == 3 && order.status_id == 2)">
           <div class="form-group">
            <label class="mb-2" for="">Comment (option)</label>
            <textarea class="form-control" v-model="comment" id="" cols="3" rows="3"></textarea>
           </div>
            <div class="form-group d-flex gap-3 mt-3 mb-2">
                <button type="button" @click="confirmOrder" class="btn-primary font-bold">
                  <i class="fas fa-check me-2"></i>
                  Confirm
                </button>
                 <button type="button" @click="cancelOrder" class="btn-danger-icon font-bold">
                  <i class="fas fa-trash me-2"></i>
                 Cancel
                </button>
              </div>
              </div>
              <div v-if="(user.role == 3 && order.status_id == 3)" class="alert alert-success mt-2 text-green">Order Confirmed</div>
<!--for operator-->
<div v-if="(user.role == 2 && (order.status_id == 3) || (order.status_id == 4))">
           <div class="form-group">
            <label class="mb-2" for="">Comment (option)</label>
            <textarea class="form-control" v-model="comment" id="" cols="3" rows="3"></textarea>
           </div>
            <div class="form-group d-flex gap-1 mt-3 mb-2">
                <button type="button" v-if="order.status_id == 3" @click="deliverOrder" class="btn-primary font-bold">
                  <i class="fas fa-arrow-right me-2"></i>
                  Deliver
                </button>
                <button type="button" v-if="order.status_id == 4" @click="completeOrder" class="btn-primary font-bold">
                  <i class="fas fa-check me-2"></i>
                  Complete
                </button>
                 <button type="button" @click="cancelOrder" class="btn-danger-icon font-bold">
                  <i class="fas fa-trash me-2"></i>
                 Cancel
                </button>
                
              </div>
              </div>
             

          </div>

        </div>
      </div>
    </div>

      </div>
</template>
<script>
import axios from "axios";

import UserAvatar from "@/components/UserAvatar.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";
import OrderFollowup from "@/components/OrderFollowup.vue";

export default {
  components: {
    UserAvatar,
    OrderStatus,
    PriceFormat,
    PhoneFormat,
    DateFormat,
    OrderFollowup
  },
  data() {
    return {
      add_btn: true,
      errors: "",
      data: [],
      tags:[],
      dataz:{},
      order:{},
      comment:"",
      selectedFollowup:5,
      selectedStaff:0,
      assign_staff_id:0,
      assign_staff_name:"Staff",
      staffs:[],
      orders:[],
      og_orders:[],
      selectedStatus:0,
      order_status:[],
      search_order:"",
      currentPage: 1,
      perPage: 10,
      user:this.$attrs.user
    };
  },
  methods: {
      async orderDatas() {
      var response = await axios
        .get(this.$store.state.api_url + "/order-datas")
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      console.log(response.data)
      if (response.data.success) {

        this.dataz = response.data.dataz;
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
      async getStaffs() {
      var response = await axios
        .post(this.$store.state.api_url + "/get-staffs",{type:"sales"})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
        this.staffs = response.data.staffs;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
          async getOrderStatus() {
      var response = await axios
        .post(this.$store.state.api_url + "/get-orders-status",{type:"operation"})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
        this.order_status = response.data.order_status;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
      async getOrders() {

      
      var response = await axios
        .post(this.$store.state.api_url + "/get-orders",{limit:100})
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        this.orders = response.data.orders;
        this.og_orders = response.data.orders;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
    async handleAssign(order) {

      const staffId = this.selectedStaff;
      if (!staffId) return;

      const staff = this.staffs.find(s => s.id === staffId);

      const confirmAssign = window.confirm(
        `Are you sure you want to assign ${staff.username}?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 2
      var order_id = order.id
      var sale_by = staff.id
      var comment = ""
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
    }
      
    },
    assignStaff(staff){

        this.assign_staff_id = staff.id
        this.assign_staff_name = staff.username
       
    },
      async assignStaffOrder(){

        var staff_name = this.assign_staff_name

          const confirmAssign = window.confirm(
        'Are you sure you want to Assign '+staff_name+'?'
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 2
      var order_id = this.order.id
      var sale_by = this.assign_staff_id
      var comment = ""
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
      }
       
    },
    handleStatus() {

      this.selectedFollowup = 5
      const id = this.selectedStatus
      this.search_order = ""
   
      const og_orders = this.og_orders

      if(id == 0){
        this.orders = og_orders
        return
      }else{
        var orders = og_orders.filter(function( obj ) {
        return obj.status_id == id;
      });

      this.orders = orders
      }
      
    },
     handleFollowup() {

      
      this.selectedStatus = 0
      const id = this.selectedFollowup
      this.search_order = ""
   
      const og_orders = this.og_orders

      if(id == 5){
        this.orders = og_orders
        return
      }else{
        var orders = og_orders.filter(function( obj ) {
        return obj.followup == id;
      });

      this.orders = orders
      }
      
    },
    addConfirmModel(order){
       this.order = order
    },
    async updateStatus(status, order_id, sale_by, comment){

         var response = await axios.post(this.$store.state.api_url + "/update-order-status",{status, order_id, sale_by, comment})
      .catch((errors) => {
        var message = "Network or Request Errors";
        alert(message)
        //this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
       // alert('Cuccessfully')

        window.location.reload()
      } else {
        alert(response.data.message)
      }
    },
      async updateFullowup(followup, order_id){

         var response = await axios.post(this.$store.state.api_url + "/update-order-followup",{order_id, followup})
      .catch((errors) => {
        var message = "Network or Request Errors";
        alert(message)
        //this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
       // alert('Cuccessfully')
        window.location.reload()
      } else {
        alert(response.data.message)
      }
    },
    async confirmOrder(){

         const confirmAssign = window.confirm(
        `Are you sure you want to Comfirm Order ?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 3
      var order_id = this.order.id
      var sale_by = this.user.id
      var comment = this.comment
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
    }
  },
      async deliverOrder(){

         const confirmAssign = window.confirm(
        `Are you sure you want to Deliver Order ?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 4
      var order_id = this.order.id
      var sale_by = this.user.id
      var comment = this.comment
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
    }
  },
      async completeOrder(){

         const confirmAssign = window.confirm(
        `Are you sure you want to Complete Order ?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 5
      var order_id = this.order.id
      var sale_by = this.user.id
      var comment = this.comment
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
    }
  },

    async cancelOrder(){

         const confirmAssign = window.confirm(
        `Are you sure you want to Cancel Order ?`
      );

      if (!confirmAssign) {
        window.location.reload()
      }else{

      var status = 6
      var order_id = this.order.id
      var sale_by = this.user.id
      var comment = this.comment
     
      // update status 

      await this.updateStatus(status, order_id, sale_by, comment)
    }
  },
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  }


  },
  computed: {

  paginatedProducts() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.orders.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.orders.length / this.perPage)
  },
  

},
watch: {
  search_order(value) {

    let term = value.toLowerCase().trim()

    if(!term){
      this.orders = this.og_orders
      return
    }

    this.orders = this.og_orders.filter(order => {

      return (
        (order.summary && order.summary.toLowerCase().includes(term)) ||
        (order.contacts && order.contacts.toLowerCase().includes(term)) ||
        (order.id && order.id.toString().includes(term)) ||
        (order.order_location && order.order_location.toLowerCase().includes(term)) ||
        (order.fullname && order.fullname.toLowerCase().includes(term))
      )

    })

  }
},
  created() {
    this.$store.state.page_name = "Orders" 
    this.orderDatas()
    this.getOrders()
    this.getStaffs()
    this.getOrderStatus()
  },
};
</script>
